<!-- eslint-disable max-len -->
<template>
  <div
    v-if="is_ready"
    id="form-master"
    class="form-master">
    <b-row>
      <b-col
        v-for="(field, index) in dataFields"
        :key="index"
        :md="field.grid">
        <b-form-group
          v-if="field.type === 'text' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <div class="tooltips">
            <j-input
              v-model="$v.formData[String(field.field_ui_key)].$model"
              :error-required="$v.formData[String(field.field_ui_key)].$error"
              :id="`base-${index}`"
              :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
              :placeholder="field.placeholder"
            />
          </div>
        </b-form-group>

        <b-form-group
          v-if="field.type === 'number' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red">*</span></label>
          <j-input
            v-model="$v.formData[String(field.field_ui_key)].$model"
            :error-required="$v.formData[String(field.field_ui_key)].$error"
            :id="`base-${index}`"
            :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
            :placeholder="field.placeholder"
            type="number"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'number_decimal' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red">*</span></label>
          <j-input
            v-model="$v.formData[String(field.field_ui_key)].$model"
            :error-required="$v.formData[String(field.field_ui_key)].$error"
            :id="`base-${index}`"
            :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
            :placeholder="field.placeholder"
            type="number"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'descriptive' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base"> {{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-textarea
            v-model="$v.formData[String(field.field_ui_key)].$model"
            :error-required="$v.formData[String(field.field_ui_key)].$error"
            :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
            :id="`base-${index}`"
            :placeholder="field.placeholder"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'date_time' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span> </label>
          <j-date-time
            :type="'datetime'"
            :data="$v.formData[String(field.field_ui_key)].$model"
            :error-required="$v.formData[String(field.field_ui_key)].$error"
            :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
            :min-datetime="field.config && field.config.is_disable_back_date ? getDateToday() : null"
            :placeholder="field.placeholder"
            :id="`base-${index}`"
            @getTimestamp="setValueDate($event, field)"/>
        </b-form-group>
        <b-form-group
          v-if="field.type === 'toggle' && !field.is_delete && !formProperties[field.field_ui_key].is_hidden"
          :class="{'error-input' : $v.formData[String(field.field_ui_key)].$error || field.error_input}">
          <label class="label-form-base">{{ field.name }} <span
            v-if="field.is_mandatory"
            style="color:red" >*</span></label>
          <j-toggle
            :id="`base-${index}`"
            v-model="$v.formData[String(field.field_ui_key)].$model"
            :disabled="field.is_editable || isDisabled || formProperties[field.field_ui_key].is_disable"
            class="toggle-form-base"/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary, import/no-extraneous-dependencies, max-len, no-unused-vars, no-eval, no-console, no-mixed-operators, no-underscore-dangle */
import { required } from 'vuelidate/lib/validators';
import jDateTime from '@/components/inputs/jDateTime';

function getValidation(field) {
  return !field.is_delete ? (field.is_mandatory ? { required } : {}) : {};
}
function generateValidations(fieldList, isDetail) {
  const validations = {
    formData: {},
  };
  fieldList.forEach((each) => {
    validations.formData[each.field_ui_key] = getValidation(each);
  });
  return validations;
}
function getDataModel(field, isDetail) {
  if (field.type === 'toggle') {
    return false;
  }
  return null;
}
function generateDataModel(fieldList, isDetail, isSearch) {
  const fields = {};
  fieldList.forEach((each) => {
    fields[each.field_ui_key] = getDataModel(each, isDetail);
  });
  return fields;
}
function generateProperties(fieldList) {
  const fields = {};
  fieldList.forEach((each) => {
    fields[each.field_ui_key] = { is_hidden: each.is_hidden || false, is_disable: false };
  });
  return fields;
}

export default {
  name: 'JFormBase',
  components: {
    jDateTime,
  },
  filters: {
    counterIndexGroup(val) {
      return Number(val) + 1;
    },
  },
  props: {
    dataFields: {
      type: Array,
      default: () => [],
    },
    isDetail: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      is_ready: false,
      formData: {},
      formProperties: {},
    };
  },
  computed: {
  },
  beforeCreate() {
    const fieldList = this.$options.propsData.dataFields;
    const isDetail = this.$options.propsData.isDetail;
    if (typeof fieldList !== 'undefined' && isDetail !== 'undefined') {
      this.$options.validations = generateValidations(fieldList, isDetail);
    }
  },
  created() {
    const fieldList = this.dataFields;
    if (fieldList) {
      this.formData = generateDataModel(fieldList, this.$options.propsData.isDetail, this.isSearch);
      this.formProperties = generateProperties(fieldList);
      this.is_ready = true;
    }
  },
  updated() {
    if (this.dataFields) {
      const elem = document.getElementsByClassName('error-input');
      if (this.$v.formData.$error && elem[0]) {
        elem[0].scrollIntoView();
        return false;
      }
      return true;
    }
    return false;
  },
  methods: {
    setErrorInput(data) {
      const dataKey = Object.keys(data);
      const dataVal = Object.values(data);

      this.dataFields.forEach((e, index) => {
        if (dataKey.includes(e.field_data_key)) {
          const findIndex = dataKey.findIndex(f => f === e.field_data_key);
          this.dataFields[index].error_input = true;
          this.dataFields[index].error_message = dataVal[findIndex];
        } else {
          this.dataFields[index].error_input = false;
          this.dataFields[index].error_message = '';
        }
      });
    },

    clearErrorInput() {
      this.dataFields.forEach((e, index) => {
        this.dataFields[index].error_input = false;
        this.dataFields[index].error_message = '';
      });
    },

    validateForm() {
      this.$v.formData.$reset();
      this.$v.formData.$touch();
      return this.$v.formData.$error;
    },

    getData() {
      return new Promise((resolve, reject) => {
        this.$v.formData.$touch();
        const validate = this.$v.formData.$error;
        if (!validate) {
          this.getComposedDataReq().then((data) => {
            resolve(data);
          });
        } else {
          reject(null);
        }
      });
    },

    getDateToday() {
      const todayDate = new Date();
      return String(this.$moment(todayDate).format('YYYY-MM-DD'));
    },

    getValueField(field, { groupField, index }) {
      return this.formData[field.field_ui_key];
    },

    getFieldFormatReq(dataField, value, { groupField, index }) {
      return new Promise((resolve) => {
        const result = {
          id: dataField.id,
          name: dataField.name,
          type: dataField.type,
          placeholder: dataField.placeholder,
          value,
        };
        resolve(result);
      });
    },

    getComposedDataReq() {
      return new Promise((resolve) => {
        const additionalData = [];
        this.dataFields.forEach((eachField) => {
          const value = this.getValueField(eachField, {});
          this.getFieldFormatReq(eachField, value, {}).then((eachDataField) => {
            additionalData.push(eachDataField);
          });
        });
        resolve(additionalData);
      });
    },

    setValueDate(val, field, childField, indexGroup) {
      this.formData[field.field_ui_key] = val;
    },
  },

  validations() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form-base/jFormBase.vue